import { Dialog } from '@mui/material';
import { IconPencil } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { Button } from 'ui';

import BuildPlanForm from './BuildPlanForm';
import { useAccount } from '../../store/account/hooks';

const EditSubscriptionModal = () => {
  const [open, setOpen] = useState(false);
  const { account, updateAccountInfo } = useAccount();
  const { subscription } = account;
  const isEditable = !subscription?.inviteId;

  if (!isEditable) return null;

  return (
    <>
      <Button title="Edit" size="sm" LeftIcon={IconPencil} onClick={() => setOpen(true)} />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        sx={{ '.MuiPaper-root': { padding: 0, margin: 0, borderRadius: '12px' } }}
      >
        <div className="px-6">
          <BuildPlanForm
            disabled={false}
            onSubmit={({ subscription }) => {
              updateAccountInfo({ subscription });
              setOpen(false);
            }}
            onCancel={() => {
              setOpen(false);
            }}
            subscription={subscription}
          />
        </div>
      </Dialog>
    </>
  );
};

EditSubscriptionModal.propTypes = {
  onConfirm: PropTypes.func,
};

export default EditSubscriptionModal;
